import {
  GET_YEARS_PENDING,
  GET_YEARS_FULFILLED,
  GET_YEARS_REJECTED,
  PATCH_YEARS_ERROR,
  SET_0KM_YEARS
} from '../actions/types';
import { dataYears } from '../utils/dataSet';

const initialState = {
  data: dataYears,
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_YEARS_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_YEARS_FULFILLED:
      return {
        ...state,
        data: { ...state.data, content: [...action.payload] },
        loading: false,
        error: false,
      };
    case GET_YEARS_REJECTED:
      return {
        ...state,
        data: dataYears,
        loading: false,
        error: true,
      };
    case SET_0KM_YEARS:
      console.log(action);
      
      return {
        ...state,
        data: { ...state.data, content: [...action.payload] },
        loading: false,
        error: false,
      };
    case PATCH_YEARS_ERROR:
      return {
        ...state,
        error: false,
      };
    default:
      return state;
  }
}
